import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/common/PageHeader';
import { usePermission } from '@/permissions/usePermission';

interface ReportItem {
  title: string;
  to: string;
  tooltip: string;
  icon: string;
  permission?: string;
}

const REPORTS: ReportItem[] = [
  {
    title: 'Latest Unique Id',
    to: '/User/RegulatoryMonitoring/CustomReports/LatestUniqueID',
    tooltip: "Show every Unique Id's country and MIFID classification at every quarter and year-end, allowing you to track changes over time",
    icon: 'fe fe-file-text',
    permission: 'User.RegulatoryMonitoring.LatestUniqueId',
  },
];

export function CustomReportsPage() {
  const can = usePermission();
  const items = REPORTS.filter((r) => can(r.permission));

  return (
    <div className="custom-reports-page">
      <PageHeader title="Custom Reports" breadcrumb={['Home', 'Custom Reports']} />

      <div className="row g-3">
        {items.map((r) => (
          <div className="col-lg-3 col-md-4 col-sm-6" key={r.to}>
            <Link to={r.to} className="text-decoration-none" title={r.tooltip}>
              <div className="card custom-card h-100 report-item-card">
                <div className="card-body d-flex align-items-center gap-3">
                  {/* Match the StatWidget icon chip (solid circle, flex-centered, fixed
                      size) instead of the theme `avatar` classes, which rendered tiny here. */}
                  <span
                    className="rounded-circle d-inline-flex align-items-center justify-content-center fs-5 text-bg-primary flex-shrink-0"
                    style={{ width: 44, height: 44 }}
                  >
                    <i className={r.icon} aria-hidden="true" />
                  </span>
                  <div>
                    <div className="fw-semibold text-default">{r.title}</div>
                    <div className="fs-12 text-muted text-truncate-2">{r.tooltip}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
        {items.length === 0 && <p className="text-muted">No reports available.</p>}
      </div>
    </div>
  );
}
